import { Pipe, PipeTransform } from '@angular/core';

/**
 * Phone with no spaces is needed for the tel link on mobile.
 */
@Pipe({
  name: 'phoneNoSpaces',
  standalone: false,
})
export class PhoneNoSpacesPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const phone = value.trim().replace(/\s+/g, '-');

    return phone;
  }
}

@Pipe({
  name: 'phoneLinkedWithDescription',
  standalone: false,
})
export class PhoneLinkedWithDescriptionPipe implements PipeTransform {
  transform(value: string, description: string): string {
    if (!value) {
      return '';
    }

    const phoneNumber = value.trim();

    description = description ? description.trim() : null;

    const phoneNumberNoSpaces = value.replace(/\s+/g, '-');

    let phone = '';

    if (description) {
      phone = `${description}: <a href="tel:${phoneNumberNoSpaces}">${phoneNumber}</a>`;
    } else {
      phone = `<a href="tel:${phoneNumberNoSpaces}">${phoneNumber}</a>`;
    }

    return phone;
  }
}

/**
 * Render an array of clickable phone numbers. Places have phone numbers coming form web api as an array.
 */
@Pipe({
  name: 'phoneArrayLinked',
  standalone: false,
})
export class PhoneArrayLinkedPipe implements PipeTransform {
  transform(value: string[]): string {
    if (!(value instanceof Array)) {
      return '';
    }

    // if array is null or empty then return
    if (!value || !value.length) {
      return '';
    }

    let linkedPhones: string = '';
    const phoneNumbers: string[] = value;

    phoneNumbers.forEach((phoneNumber) => {
      if (phoneNumber) {
        if (linkedPhones !== '') {
          linkedPhones += ', '; // add a comma in front if it's not the first number
        }
        const phoneNumberNoSpaces = phoneNumber.replace(/\s+/g, '-');
        linkedPhones += `<a href="tel:${phoneNumberNoSpaces}">${phoneNumber}</a>`;
      }
    });

    return linkedPhones;
  }
}

@Pipe({
  name: 'webAddress',
  standalone: false,
})
export class WebAddressPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const webAddress = value.replace('http://', '').replace('https://', '');

    return webAddress;
  }
}
